import { Link } from 'react-router-dom';

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <section className="bg-white py-12 md:py-20">
        <div className="container mx-auto px-6 md:px-12 lg:px-24">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl sm:text-5xl font-bold mb-8" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Terms & <span className="text-[#1E88E5]">Conditions</span>
            </h1>

            <div className="prose prose-lg max-w-none text-[#334155]">
              <p className="text-lg mb-6">
                <strong>Effective Date:</strong> January 1, 2024
              </p>

              <p className="mb-6">
                Welcome to Gomez Cleaning Service LLC. By using our website and services, you agree to be bound by the following terms and conditions. Please read them carefully.
              </p>

              <h2 className="text-2xl font-bold text-[#0F172A] mt-10 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                1. Services
              </h2>
              <p className="mb-6">
                Gomez Cleaning Service LLC provides professional cleaning services including commercial cleaning, residential cleaning, post-construction cleaning, window cleaning, power washing, and emergency cleaning services. The scope of each service will be agreed upon before work begins.
              </p>

              <h2 className="text-2xl font-bold text-[#0F172A] mt-10 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                2. Quotes and Pricing
              </h2>
              <ul className="list-disc pl-6 mb-6 space-y-2">
                <li>All quotes are free and provided based on the information you supply.</li>
                <li>Final pricing may vary if the actual conditions differ from what was described.</li>
                <li>We reserve the right to adjust pricing for additional services requested.</li>
                <li>Payment terms will be agreed upon before services are rendered.</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#0F172A] mt-10 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                3. Scheduling and Cancellation
              </h2>
              <ul className="list-disc pl-6 mb-6 space-y-2">
                <li>Appointments can be scheduled via phone, email, or our website contact form.</li>
                <li>We appreciate at least 24 hours notice for cancellations or rescheduling.</li>
                <li>Same-day cancellations may be subject to a cancellation fee.</li>
                <li>Emergency services are available 24/7 and may have different terms.</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#0F172A] mt-10 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                4. Access and Preparation
              </h2>
              <p className="mb-6">
                Clients must provide safe access to the areas to be cleaned. We recommend:
              </p>
              <ul className="list-disc pl-6 mb-6 space-y-2">
                <li>Removing or securing valuable and fragile items</li>
                <li>Ensuring our team can access all areas to be cleaned</li>
                <li>Providing any necessary keys, codes, or access instructions</li>
                <li>Informing us of any special requirements or concerns</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#0F172A] mt-10 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                5. Satisfaction Guarantee
              </h2>
              <p className="mb-6">
                We strive for your complete satisfaction. If you are not satisfied with our services:
              </p>
              <ul className="list-disc pl-6 mb-6 space-y-2">
                <li>Please notify us within 24 hours of service completion.</li>
                <li>We will return to address any concerns at no additional charge.</li>
                <li>Our team will make every effort to resolve issues promptly.</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#0F172A] mt-10 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                6. Insurance and Liability
              </h2>
              <p className="mb-6">
                Gomez Cleaning Service LLC is fully licensed and insured. However:
              </p>
              <ul className="list-disc pl-6 mb-6 space-y-2">
                <li>We are not liable for damage to items not properly disclosed or secured.</li>
                <li>Pre-existing damage should be reported before cleaning begins.</li>
                <li>Liability is limited to the cost of services provided.</li>
                <li>Any claims must be reported within 48 hours of service completion.</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#0F172A] mt-10 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                7. Website Use
              </h2>
              <p className="mb-6">
                By using our website, you agree to:
              </p>
              <ul className="list-disc pl-6 mb-6 space-y-2">
                <li>Provide accurate information when contacting us</li>
                <li>Not misuse or attempt to harm our website</li>
                <li>Respect our intellectual property rights</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#0F172A] mt-10 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                8. Changes to Terms
              </h2>
              <p className="mb-6">
                We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting on our website. Continued use of our services constitutes acceptance of any changes.
              </p>

              <h2 className="text-2xl font-bold text-[#0F172A] mt-10 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                9. Contact Information
              </h2>
              <p className="mb-6">
                For questions about these terms, please contact us:
              </p>
              <ul className="list-none mb-6 space-y-2">
                <li><strong>Email:</strong> gelvia26@gmail.com</li>
                <li><strong>Phone:</strong> (323) 378-0061</li>
                <li><strong>Address:</strong> Sylmar, CA 91342</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#0F172A] mt-10 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                10. Governing Law
              </h2>
              <p className="mb-6">
                These terms are governed by the laws of the State of California. Any disputes shall be resolved in the courts of Los Angeles County, California.
              </p>

              <div className="mt-10 pt-6 border-t border-[#E2E8F0]">
                <Link to="/" className="text-[#1E88E5] hover:underline">
                  ← Back to Home
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
